import React from 'react';
import './chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';
import ChapterHeader from '../ChapterHeader/ChapterHeader';
import FloatingCubes from '../FloatingCubes/FloatingCubes';
import imageS from '../../assets/ch4-m.png';
import imageWebP from '../../assets/ch4-m.webp';
import Quote from '../Quote/Quote';

function Chapter4() {
  const hyperlinkData = [
    {
      copy: 'Lama Nachman',
      href: 'https://www.intel.com/content/www/us/en/research/featured-researchers/lama-nachman.html',
      label: "Visit Lama Nachman's page"
    }
  ];
  return (
    <section className="chapters">
      <ChapterHeader chIndex={3} />
      <FloatingCubes origin="ch4" reverse={true} screen="l" />
      <div className="chapters__body">
        <h3 className="chapters__head">
          <span className="chapters__head__number">4</span>
          <span className="chapters__head__copy">
            Empowering People to Overcome Disabilities Like Never Before
          </span>
        </h3>

        <p>
          For people with severe physical disabilities, things as basic as expression,
          communication, and access to information can be consistently out of reach. But for the
          past 26 years, <Hyperlink hyperlinkData={hyperlinkData[0]} /> of Intel Labs has pioneered
          new tech in areas like Context-Aware Computing, Multi-Modal Interactions, and Human/AI
          systems. The result is Intel’s{' '}
          <span className="italic">Assistive Context-Aware Toolkit</span> (ACAT) an AI-powered
          system that allows people with severe disabilities to communicate through keyboard
          simulation, word prediction, speech synthesis, and more.
        </p>
        <p>
          Nachman’s journey to developing ACAT began early in her tenure at Intel when her team was
          tasked with developing new assistive solutions for a longtime customer and collaborator
          who faced new health complications that limited his motor skills. And due to the nature of
          his condition, future-proofing this interface would require all-new methodologies and tech
          that simply hadn’t been invented.
        </p>

        <Quote />
        <p>
          “Somebody might be able to slightly move a finger,” Nachman says. “Somebody might be able
          to smile. [Is there] any possible way we can extract a signal through sensing and making
          sense of that data that can then map onto the equivalent of a push button?” By broadening
          the range of methodologies for “sensing” input and organizing them into an open-source
          system, Nachman’s team was able to offer a more sustainable long-term solution for this
          unique set of challenges. In the process, they paved the way for{' '}
          <span className="bluebold">
            an open-source framework that could be configured for virtually{' '}
            <span className="italic">any</span> assistive use case.
          </span>
        </p>
        <div className="chapters__photoS chapters__photoS-1">
          <picture>
            <source srcSet={imageWebP} />
            <source srcSet={imageS} />
            <img src={imageS} alt="" />
          </picture>
        </div>
      </div>
    </section>
  );
}

export default Chapter4;
